import { Injectable } from '@angular/core';
import { uniq, slice } from 'lodash';
import { SpiEchartsUtils } from '../../services/spi.echarts.utils';
import { SpiUtils } from '../../services/spi.utils';
import { ValidatorUtils } from '../../utils/validator.utils';
import { ChartQueue } from '../../queue/chart.queue';

import { extend } from 'jquery';
declare let ecStat: any;

@Injectable({ providedIn: 'root' })
export class PivotTableRenderers {

  chartType;
  dataArray;
  drillDownData: any[] = [];
  rowKeys: any[] = [];
  colKeys: any[] = [];

  isNumericColKeys = true;
  isNumericRowKeys = true;

  constructor(private validatorUtils: ValidatorUtils,
    private chartQueue: ChartQueue,
    private spiEchartsUtils: SpiEchartsUtils, private spiUtils: SpiUtils) {
  }

  /**********************************************/
  /**************** DATA ***********************/

  /*********************************************/
  calculateDataArray(optsData, that) {
    let headers, h;
    if (optsData.usePivot) {
      that.rowKeys = optsData.getRowKeys();
      that.colKeys = optsData.getColKeys();

      headers = (function () {
        let i, len, results;
        results = [];
        for (i = 0, len = that.rowKeys.length; i < len; i++) {
          h = that.rowKeys[i];
          results.push(h.join('-'));
        }
        return results;
      })();
      headers.unshift('');

      that.distinctColKeys = that.colKeys;
      if (optsData.useDrill) {
        that.distinctColKeys = [];
        for (let i = 0; i < that.colKeys.length; i++) {
          let drillLeve = that.drillDownData.length + 1;
          let aux = [];
          for (let j = 0; j < drillLeve; j++) {
            if (j < that.drillDownData.length &&
              that.drillDownData[j] !== that.colKeys[i][j]) {
              continue;
            }
            aux.push(that.colKeys[i][j]);
          }
          if (aux.length === drillLeve) {
            that.distinctColKeys.push(aux);
          }
        }
        that.distinctColKeys = that.uniqueInMatrix(that.distinctColKeys);
        for (let i = 0; i < that.distinctColKeys.length; i++) {
          that.distinctColKeys[i] = that.distinctColKeys[i];
        }
      }
      if (that.chartType === 'scatter' || that.chartType === 'effectScatter') {
        that.dataArray = that.createDataSourceForScatter(optsData, that.distinctColKeys, that.rowKeys, headers);
      } else {
        that.dataArray = that.createDataSource(optsData, that.distinctColKeys, that.rowKeys, headers);
      }
    } else {
      that.rowKeys = optsData.rows;
      that.colKeys = optsData.cols;
      that.dataArray = that.createDataSourceFromBrutInput(optsData.data, that.colKeys, that.rowKeys);
    }

    return that.dataArray;
  }

  private uniqueInMatrix(matrix: Array<Array<string>>) {
    let aux = [], res = [];
    for (let i = 0; i < matrix.length; i++) {
      let t = matrix[i];
      aux.push(t.join('-'));
    }
    aux = uniq(aux);
    for (let i = 0; i < aux.length; i++) {
      res.push(aux[i].split('-'));
    }
    return res;
  }

  private createDataSource(pivotData, colKeys, rowKeys, headers) {
    let val, colKey, rowKey;

    let rowAttrs = pivotData.rowAttrs;
    let colAttrs = pivotData.colAttrs;

    let numCharsInHAxis = 0;
    let dataArray = [headers];
    if (colKeys.length !== 0) {
      for (let i = 0, len = colKeys.length; i < len; i++) {
        colKey = colKeys[i];
        const row = [colKey.join('-')];
        numCharsInHAxis += row[0].length;
        for (let j = 0, len1 = rowKeys.length; j < len1; j++) {
          rowKey = rowKeys[j];
          let agg = pivotData.getAggregator(rowKey, colKey);
          if (agg.value() !== null) {
            val = agg.value();
            if ($.isNumeric(val)) {
              if (val < 1) {
                row.push(parseFloat(val.toPrecision(3)));
              } else {
                row.push(parseFloat(val.toFixed(3)));
              }
            } else {
              row.push(val);
            }
          } else {
            row.push(null);
          }
        }
        if (rowKeys.length === 0) {
          let aggTotal = pivotData.colTotals[colKey.join('\u0000')];
          row.push(aggTotal.value());
        }
        dataArray.push(row);
      }
    } else {
      if (rowKeys.length !== 0) {
        let arrTranspose = [];
        let rowTotal = [];
        for (let y = 0, len3 = rowKeys.length; y < len3; y++) {
          let keyTotal, aggTotal, val = null;
          let key = rowKeys[y];
          if (key) {
            keyTotal = key.join('\u0000');
            aggTotal = pivotData.rowTotals[keyTotal];
            if (aggTotal) {
              val = aggTotal.value();
            }
          }
          arrTranspose.push([keyTotal, val]);
        }
        dataArray = arrTranspose;
      }
    }
    if (rowKeys.length === 0 && colKeys.length !== 0) {
      dataArray[0] = ['COL', colAttrs.join('-')];
    }
    if (colKeys.length === 0 && rowKeys.length !== 0) {
      dataArray.unshift(['COL', rowAttrs.join('-')]);
    }
    return dataArray;
  }

  private createDataSourceForScatter(pivotData, colKeys, rowKeys) {
    let val, colKey, rowKey;
    this.isNumericColKeys = true;
    this.isNumericRowKeys = true;
    let dataArray = [];
    if (colKeys.length !== 0 && rowKeys.length !== 0) {
      for (let i = 0, len = colKeys.length; i < len; i++) {
        for (let j = 0, len1 = rowKeys.length; j < len1; j++) {
          colKey = colKeys[i];
          rowKey = rowKeys[j];

          let cell = [colKey.join('-') * 1];
          if (!this.validatorUtils.isNumber(colKey.join('-'))) {
            this.isNumericColKeys = false;
            cell = [colKey.join('-')];
          }
          let cell2 = rowKey.join('-') * 1;
          if (!this.validatorUtils.isNumber(rowKey.join('-'))) {
            this.isNumericRowKeys = false;
            cell2 = rowKey.join('-');
          }
          cell.push(cell2);
          let agg = pivotData.getAggregator(rowKey, colKey);
          if (agg.value() !== null) {
            val = agg.value();
            if ($.isNumeric(val)) {
              if (val < 1) {
                cell.push(parseFloat(val.toPrecision(3)));
              } else {
                cell.push(parseFloat(val.toFixed(3)));
              }
            } else {
              cell.push(val);
            }
            dataArray.push(cell);
          }
        }
      }
    }

    if (colKeys.length !== 0 && rowKeys.length === 0) {
      for (let i = 0; i < pivotData.colKeys.length; i++) {
        let val = pivotData.colTotals[pivotData.colKeys[i][0]].value();
        if ($.isNumeric(val)) {
          if (val < 1) {
            val = parseFloat(val.toPrecision(3));
          } else {
            val = parseFloat(val.toFixed(3));
          }
        }
        dataArray.push([Number(pivotData.colKeys[i][0]), Number(val)]);
      }
    }

    return dataArray;
  }

  private createDataSourceFromBrutInput(pivotData, colKeys, rowKeys) {
    let matrix = [], row = [];

    row.push(colKeys[0]);
    for (let i in pivotData) {
      let obj = pivotData[i];
      row.push(obj[colKeys[0]]);
    }
    matrix.push(row);

    for (let j in rowKeys) {
      row = [];
      row.push(rowKeys[j]);
      for (let i in pivotData) {
        let obj = pivotData[i];
        row.push(obj[rowKeys[j]]);
      }
      matrix.push(row);
    }

    return matrix;
  }

  private matrixToNumericFlatArray(matrix: any[][], onlyNumeric) {
    let res = [];
    for (let i = 0; i < matrix.length; i++) {
      for (let j = 0; j < matrix[i].length; j++) {
        if (onlyNumeric) {
          if (!isNaN(matrix[i][j])) {
            res.push(matrix[i][j]);
          }
        } else {
          res.push(matrix[i][j]);
        }
      }
    }
    return res;
  }

  // *****************************************************
  // *** Create Options RENDERER FOR DATASET ECHARTS
  // Suppoerted chart : line, bar, hbar, stack-line, stack-hbar, stack-bar, pie, multi-pie, scatter
  // *****************************************************
  echartsRendererFromDatasource(chartType, extraOptions, that) {
    return (optsData, opts, elt) => {

      let headers, title, vAxisTitle, hAxisTitle;

      // $$$$$$$$$$$$$$ READ DATA $$$$$$$$$$$$$$$$$$$
      that.chartType = chartType;
      that.drillDownData = [];
      that.calculateDataArray(optsData, that);

      if (optsData.usePivot) {
        // Title
        title = optsData.aggregatorName;
        if (optsData.valAttrs.length) {
          title += '(' + (optsData.valAttrs.join(', ')) + ')';
        }
        vAxisTitle = optsData.rowAttrs.join('-');
        hAxisTitle = optsData.colAttrs.join('-');
        if (hAxisTitle !== '') {
          title += ' ' + opts.localeStrings.vs + ' ' + hAxisTitle;
        }
        let groupByTitle = optsData.rowAttrs.join('-');
        if (groupByTitle !== '') {
          title += ' ' + opts.localeStrings.by + ' ' + groupByTitle;
        }
      }

      // $$$$$$$$$$$$$$ RENDER $$$$$$$$$$$$$$$$$$$
      that.chartOptions = {
        baseOption: {
          legend: {},
          tooltip: {},
          dataset: {
            source: that.dataArray
          },
          xAxis: { type: 'category', boundaryGap: true },
          yAxis: {},
          series: []
        },
        options: [],
        media: [{
          query: { maxWidth: 500 },
          option: {
            title: { textStyle: { fontSize: 10 } },
            toolbox: { show: false },
            legend: { textStyle: { fontSize: 11 } },
            dataZoom: { handleSize: 20, height: 15 }
          }
        }]
      };

      if (opts) {
        extend(true, that.chartOptions.baseOption, opts);
      }

      if (that.chartType === 'scatter' || that.chartType === 'effectScatter') {
        let aux = that.chartOptions.baseOption.xAxis;
        if (that.isNumericColKeys) {
          that.chartOptions.baseOption.xAxis = { splitLine: { lineStyle: { type: 'dashed' } } };
        } else {
          that.chartOptions.baseOption.xAxis = { splitLine: { lineStyle: { type: 'dashed' } }, type: 'category', data: [] };
          let aux = [];
          for (let i = 0; i < that.dataArray.length; i++) {
            aux.push(that.dataArray[i][0]);
          }
          that.chartOptions.baseOption.xAxis.data = uniq(aux);
        }
        if (that.isNumericRowKeys) {
          that.chartOptions.baseOption.yAxis = { splitLine: { lineStyle: { type: 'dashed' } }, scale: true };
        } else {
          that.chartOptions.baseOption.yAxis = {
            splitLine: { lineStyle: { type: 'dashed' } },
            type: 'category',
            data: that.matrixToNumericFlatArray(that.rowKeys, false)
          };
        }
        delete that.chartOptions.baseOption.dataset;

        let flatArray = that.matrixToNumericFlatArray(that.dataArray, true);
        let max, min;
        min = Math.min.apply(Math, flatArray);
        max = Math.max.apply(Math, flatArray);
        extend(true, that.chartOptions.baseOption, {
          visualMap: {
            right: 0, min: min, max: max, bottom: 'center',
            dimension: 2, itemWidth: 10, itemHeight: 80, calculable: true,
            inRange: { symbolSize: [20, 60] },
            text: ['MAX', 'MIN']
          }
        });
        that.chartOptions.baseOption.grid.right = 50;
      }

      if (that.chartType === 'hbar' || that.chartType === 'stack-hbar') {
        let aux = that.chartOptions.baseOption.xAxis;
        that.chartOptions.baseOption.xAxis = that.chartOptions.baseOption.yAxis;
        that.chartOptions.baseOption.yAxis = aux;
      }

      if (that.chartType === 'pie' || that.chartType === 'multi-pie' || that.chartType === 'funnel') {
        delete that.chartOptions.baseOption.xAxis;
        delete that.chartOptions.baseOption.yAxis;
        delete that.chartOptions.baseOption.dataZoom;
        delete that.chartOptions.media[0].option.dataZoom;
        that.chartOptions.baseOption.toolbox.feature.dataZoom.show = false;
        that.chartOptions.baseOption.toolbox.feature.dataView.show = false;
        that.chartOptions.baseOption.toolbox.feature.magicType.show = false;
        that.chartOptions.baseOption.toolbox.feature.restore.show = false;
      }

      if (that.chartType !== 'scatter' && that.chartType !== 'effectScatter') {
        delete that.chartOptions.baseOption.visualMap;
      }

      if (that.chartType === 'hbar' || that.chartType === 'stack-hbar') {
        delete that.chartOptions.baseOption.dataZoom;
      }
      if (that.chartType !== 'multi-pie') {
        delete that.chartOptions.baseOption.timeline;
      }
      if (that.chartType === 'multi-pie') {
        that.chartOptions.baseOption.legend = {
          show: true, type: 'scroll', orient: 'vertical', right: 10, top: 70
        };
      }

      if (that.chartType === 'line' || that.chartType === 'area') {
        that.chartOptions.baseOption.xAxis.boundaryGap = false;
      }

      // Legend
      if (that.spiUtils.isDefined(that.chartOptions.baseOption.legend)) {
        delete that.chartOptions.baseOption.legend.data;
      }
      let series = [];
      //**************
      if (optsData.usePivot) {

        if (that.chartType === 'scatter' || that.chartType === 'effectScatter') {

          series = [
            {
              type: that.chartType,
              symbol: 'circle',
              data: that.dataArray
            }
          ];
        } else {
          let firstRow = that.dataArray[0];
          if (that.colKeys.length !== 0 && that.rowKeys.length !== 0) {
            for (let index = 1; index < firstRow.length; index++) {
              if (that.chartType === 'multi-pie') {
                series.push(
                  {
                    title: { text: firstRow[index] },
                    series: [{
                      type: 'pie', radius: ['40%', '60%'], encode: { itemName: '', value: firstRow[index] }
                    }]
                  }
                );
                that.chartOptions.baseOption.timeline.data.push(firstRow[index]);
              } else {
                series.push(that.createSerie(that.chartType));
              }
            }
          }
          if (that.colKeys.length !== 0 && that.rowKeys.length === 0) {
            series.push(that.createSerie(that.chartType));
          }
          if (that.colKeys.length === 0 && that.rowKeys.length !== 0) {
            for (let index = 1; index < that.dataArray.length; index++) {
              let serie = that.createSerie(that.chartType);
              extend(true, serie, { seriesLayoutBy: 'row' });
              series.push(serie);
            }
          }
        }
      } else {
        for (let index = 1; index < that.dataArray.length; index++) {
          let s = that.createSerie(that.chartType);
          extend(true, s, { seriesLayoutBy: 'row' });
          series.push(s);
        }
      }

      /******************************************/
      /********** STATS *************/
      /******************************************/
      if (optsData.usePivot && that.chartOptions.baseOption.stats && that.chartOptions.baseOption.stats.show) {
        try {
          let data = [];
          if (that.chartOptions.baseOption.stats.api === 'regression' || that.chartOptions.baseOption.stats.api === 'clustering') {
            for (let i = 0; i < optsData.colKeys.length; i++) {
              let val = optsData.colTotals[optsData.colKeys[i][0]].value();
              val = val * 1;
              if (val < 1) {
                val = parseFloat(val.toPrecision(3));
              } else {
                val = parseFloat(val.toFixed(3));
              }
              data.push([optsData.colKeys[i][0] * 1, val]);
            }
          }
          if (that.chartOptions.baseOption.stats.api === 'regression') {
            let myRegression = ecStat.regression(that.chartOptions.baseOption.stats.method, data);
            if (that.chartOptions.baseOption.stats.method === 'polynomial') {
              myRegression = ecStat.regression('polynomial', data, that.chartOptions.baseOption.stats.order);
            }
            myRegression.points.sort((a, b) => {
              return a[0] - b[0];
            });
            series.push({
              name: 'Expression|' + that.chartOptions.baseOption.stats.method,
              type: 'line', showSymbol: false, smooth: true, data: myRegression.points
            });
            if (that.chartOptions.baseOption.title) {
              that.chartOptions.baseOption.title.subtext = 'Expression: (' + that.chartOptions.baseOption.stats.method + ') ' + myRegression.expression;
            }
          }
          if (that.chartOptions.baseOption.stats.api === 'clustering') {
            var step = ecStat.clustering.hierarchicalKMeans(data, 3, true);
            console.log(step);
          }
          if (that.chartOptions.baseOption.stats.api === 'histogram') {

          }
          if (that.chartOptions.baseOption.stats.api === 'statistics') {

          }
        } catch (error) {
          if (typeof console !== 'undefined' && console !== null) {
            console.error(error.stack);
          }
        }
      }

      if (that.chartType === 'multi-pie') {
        delete that.chartOptions.baseOption.series;
        that.chartOptions.options = series;
      } else {
        if (that.chartOptions.baseOption.series && that.chartOptions.baseOption.series.length > 0 && that.chartOptions.baseOption.series[0].type !== 'scatter' && that.chartOptions.baseOption.series[0].type !== 'effectScatter') {
          for (let i = 0; i < that.chartOptions.baseOption.series.length; i++) {
            delete that.chartOptions.baseOption.series[i].data;
          }
          for (let i = 0; series && i < series.length; i++) {
            delete that.chartOptions.baseOption.series[i].data;
            extend(true, series[i], that.chartOptions.baseOption.series[i]);
          }
          //extend(true, series, that.chartOptions.baseOption.series);
        }
        that.chartOptions.baseOption.series = series;
      }
      if (that.chartOptions.baseOption.title && that.chartOptions.baseOption.title.text === '') {
        that.chartOptions.baseOption.title.text = title;
      }

      delete that.chartOptions.baseOption.localeStrings;
      //console.log(JSON.stringify(that.chartOptions));
      return that.pinEchartsInDiv(elt, that.chartOptions, that, optsData);
    };
  }

  private createSerie(chartType) {
    let type = chartType;
    let markLine = {};
    let markPoint = {};
    /*if (chartType === 'line' || chartType === 'bar') {
        markLine = { data: [
            {type: 'max', name : 'Maximum'},
            [ { name: 'Minimum to Maximum', type: 'min' },  { type: 'max' } ]
          ]
        };
    }
    if (chartType === 'bar') {
      markPoint = { data: [ {type: 'max', name : 'Maximum'} ] };
    }*/
    if (chartType === 'stack-bar' || chartType === 'hbar' || chartType === 'stack-hbar') {
      type = 'bar';
    }
    if (chartType === 'multi-pie') {
      type = 'pie';
    }
    if (chartType === 'area') {
      type = 'line';
    }
    let serie: any = { type: type, markLine: markLine, markPoint: markPoint };

    if (chartType === 'stack-bar' || chartType === 'stack-hbar') {
      serie = { type: type, stack: 'stack' };
    }
    if (chartType === 'area') {
      serie = { type: type, areaStyle: {}, stack: 'stack' };
    }
    return serie;
  }

  // *****************************************************
  // *** Create Options RENDERER Flat Echarts
  // *****************************************************
  echartsRenderer(chartType, extraOptions, that) {
    return (pivotData, opts, elt) => {

      let agg, colKey, dataArray, groupByTitle, h, headers, i, j, len, len1, numCharsInHAxis, row, rowKey, title, val;

      that.drillDownData = [];

      // Read data
      let colAttrs = pivotData.colAttrs;
      let rowAttrs = pivotData.rowAttrs;
      let rowKeys = pivotData.getRowKeys();
      let colKeys = pivotData.getColKeys();

      // Init configuration
      let optionTmp: any = {};
      that.spiEchartsUtils.initGrapheByType(optionTmp, chartType);

      // Title
      title = pivotData.aggregatorName;
      if (pivotData.valAttrs.length) {
        title += '(' + (pivotData.valAttrs.join(', ')) + ')';
      }
      optionTmp.title.show = true;
      optionTmp.title.text = title;
      //optionTmp.title.subtext = title;

      // Options
      optionTmp.tooltip.show = true;
      optionTmp.toolbox.show = true;

      headers = (function () {
        let i, len, results;
        results = [];
        for (i = 0, len = rowKeys.length; i < len; i++) {
          h = rowKeys[i];
          results.push(h.join('-'));
        }
        return results;
      })();
      headers.unshift('');

      let vAxisTitle = pivotData.rowAttrs.join('-');
      let hAxisTitle = pivotData.colAttrs.join('-');
      if (hAxisTitle !== '') {
        title += ' ' + opts.localeStrings.vs + ' ' + hAxisTitle;
      }

      groupByTitle = pivotData.rowAttrs.join('-');
      if (groupByTitle !== '') {
        title += ' ' + opts.localeStrings.by + ' ' + groupByTitle;
      }

      // specify chart configuration item and data
      headers.shift();

      numCharsInHAxis = 0;

      dataArray = [headers];
      if (colKeys.length !== 0) {
        for (i = 0, len = colKeys.length; i < len; i++) {
          colKey = colKeys[i];
          row = [colKey.join('-')];
          numCharsInHAxis += row[0].length;
          for (j = 0, len1 = rowKeys.length; j < len1; j++) {
            rowKey = rowKeys[j];
            agg = pivotData.getAggregator(rowKey, colKey);
            if (agg.value() !== null) {
              val = agg.value();
              if ($.isNumeric(val)) {
                if (val < 1) {
                  row.push(parseFloat(val.toPrecision(3)));
                } else {
                  row.push(parseFloat(val.toFixed(3)));
                }
              } else {
                row.push(val);
              }
            } else {
              row.push(null);
            }
          }
          dataArray.push(row);
        }
      }

      // Legend
      if (that.spiUtils.isDefined(optionTmp.legend)) {
        optionTmp.legend.data = [];
        optionTmp.legend.type = 'scroll';
      }
      optionTmp.legend.data = [];

      // xAxis and yAxis
      if (chartType !== 'hbar' && chartType !== 'stack-hbar') {
        if (!that.spiUtils.isDefined(optionTmp.xAxis[0])) {
          optionTmp.xAxis.push({
            show: true,
            position: 'bottom',
            name: 'X',
            type: 'category',
            boundaryGap: true,
            data: [],
            axisTick: { show: false },
            nameLocation: 'end',
            nameRotate: null,
            min: null,
            max: null
          });
          optionTmp.xAxis[0].data = headers;
        } else {
          optionTmp.xAxis[0].data = headers;
        }
        optionTmp.yAxis.push({ 'type': 'value' });
      } else {
        if (!that.spiUtils.isDefined(optionTmp.xAxis[0])) {
          optionTmp.yAxis.push({
            show: true,
            name: 'Y',
            type: 'category',
            boundaryGap: true,
            data: [],
            axisTick: { show: false },
            nameLocation: 'end',
            nameRotate: null,
            min: null,
            max: null
          });
          optionTmp.yAxis[0].data = headers;
        } else {
          optionTmp.yAxis[0].data = headers;
        }
        optionTmp.xAxis.push({ 'type': 'value' });
      }

      if (chartType === 'scatter' || chartType === 'effectScatter') {
        optionTmp.xAxis = [{ 'type': 'value' }];
        optionTmp.yAxis = [{ 'type': 'value' }];
      }


      optionTmp.series = [];
      for (let index = 1; index < dataArray.length; index++) {
        let arr = dataArray[index];
        let titleSerie = arr[0];
        arr.shift();

        if (chartType === 'stack-bar' || chartType === 'stack-hbar') {
          optionTmp.series.push({
            name: titleSerie,
            id: titleSerie,
            stack: 'stack',
            type: 'bar',
            label: {
              normal: {
                show: false,
                position: 'top'//'inside'
              }
            },
            data: arr
          });
        }
        if (chartType === 'bar' || chartType === 'hbar') {
          optionTmp.series.push({
            name: titleSerie,
            id: titleSerie,
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
            data: arr
          });
        }
        if (chartType === 'line') {
          optionTmp.series.push({
            name: titleSerie,
            id: titleSerie,
            type: 'line',
            label: {
              normal: {
                show: false,
                position: 'top'
              }
            },
            data: arr
          });
        }
        if (chartType === 'area') {
          optionTmp.series.push({
            name: titleSerie,
            id: titleSerie,
            type: 'line',
            stack: 'stack',
            areaStyle: {},
            label: {
              normal: {
                show: false,
                position: 'top'
              }
            },
            data: arr
          });
        }

        if (chartType === 'scatter' || chartType === 'effectScatter') {
          optionTmp.series.push({
            name: titleSerie,
            id: titleSerie,
            type: 'line',
            stack: 'stack',
            areaStyle: {},
            label: {
              normal: {
                show: false,
                position: 'top'
              }
            },
            data: arr
          });
        }

        optionTmp.legend.data.push(titleSerie);
      }
      return that.pinEchartsInDiv(elt, optionTmp, that, pivotData);
    };
  }

  // ****************************************************
  // *** Create Options GEO/MAP Render
  // ****************************************************
  echartsGeoMapRenderer(chartType, extraOptions, that) {
    return (pivotData, opts, elt) => {

      // Init configuration
      let optionTmp: any = opts;

      extend(true, optionTmp, this.spiEchartsUtils.baseOptionEchart);
      extend(true, optionTmp, this.spiEchartsUtils.grid);
      //extend(true, config, {geo : {gedodataId : 0}});
      //extend(true, optionTmp, this.spiEchartsUtils.map);
      delete optionTmp.toolbox;
      delete optionTmp.timeline;
      delete optionTmp.dataZoom;
      delete optionTmp.tooltip;

      let geoId = 0;
      let mapName = 'world';
      if (this.spiUtils.isDefined(optionTmp.geo) && this.spiUtils.isDefined(optionTmp.geo.gedodataId)) {
        geoId = optionTmp.geo.gedodataId;
        if (optionTmp.geo.map && optionTmp.geo.map !== '') {
          mapName = optionTmp.geo.map;
        }
      }

      // series and data
      let inputData = pivotData.input ? pivotData.input : pivotData.data;
      let data = [];
      if (inputData && inputData.length > 0
        && pivotData.colAttrs && pivotData.colAttrs.length > 0
        && pivotData.rowAttrs && pivotData.rowAttrs.length > 0) {
        const colName = pivotData.colAttrs[0];
        const valName = pivotData.rowAttrs[0];
        for (let i = 0; i < inputData.length; i++) {
          let row = inputData[i];
          data.push({
            name: row[colName],
            value: row[valName]
          });
        }
      }
      optionTmp['series'] = [];
      optionTmp.series.push({
        type: 'map',
        map: mapName,
        roam: true,
        geoIndex: 0,
        data: data
      });

      if (!geoId || geoId === 0) {
        const geodataWorld = localStorage.getItem('geodata.world');
        if (geodataWorld) {
          optionTmp.geo.map = mapName;

          void import('echarts').then(
            echarts => {
              echarts.registerMap(mapName, JSON.parse(geodataWorld));
            });

          return that.pinEchartsInDiv(elt, optionTmp, that, pivotData);
        } else {
          /*this.geodataService.loadLocalGeodata('world')
            .subscribe(res => {
              if (res) {
                optionTmp.geo.map = mapName;
                localStorage.setItem('geodata.world', JSON.stringify(res));
                echarts.registerMap(mapName, res);
                return that.pinEchartsInDiv(elt, optionTmp, that, pivotData);
              }
            }, err => {
              console.log(err);
            });*/
        }
      } else {
        /*this.geodataService.getById(geoId)
          .subscribe(res => {
            if (res && res.result) {
              if (optionTmp.geo) {
                echarts.registerMap(mapName, JSON.parse(res.result.content));
                optionTmp.geo.map = mapName;
                return that.pinEchartsInDiv(elt, optionTmp, that, pivotData);
              }
            }
          }, err => {
            console.log(err);
          });*/
      }

    };
  }

  // ****************************************************
  // *** Render into the DOM
  // ****************************************************
  private pinEchartsInDiv(elt, optionTmp, that, optsData) {
    let div = $('<div>');
    div.css('height', '350px');
    div.appendTo($(elt));
    let theme = 'roma';
    if (optionTmp.theme || (optionTmp.baseOption && optionTmp.baseOption.theme)) {
      theme = optionTmp.theme || optionTmp.baseOption.theme;
    }

    void import('echarts').then(
      echarts => {
        const myChart = echarts.init(div[0], theme, { renderer: 'svg' });

        myChart.setOption(optionTmp, true);
        if (optionTmp.baseOption && optionTmp.baseOption.series) {
          this.chartQueue.renderChartIsFinishedEvent({ series: optionTmp.baseOption.series });
        }


        myChart.on('click', (params) => {
          console.log(params);
        });
        if (optsData.useDrill) {
          myChart.on('click', (params) => {
            console.log(params);
            if (params.componentType === 'series') {
              let auxkey = params.name.split('-');
              if (that.colKeys.length > 0 && that.drillDownData.length < that.colKeys[0].length - 1) {
                that.drillDownData.push(auxkey[auxkey.length - 1]);
                that.dataArray = that.calculateDataArray(optsData, that);

                let subtitle = '', invisible = false;
                subtitle = 'Drill down into : ' + that.drillDownData.join(' > ');
                let opt: any = {}, aux = [], graphic = [];
                graphic = [
                  {
                    type: 'group', left: 5, top: 45, z: 10, id: 'drillUp', invisible: invisible, draggable: true,
                    children: [
                      {
                        invisible: invisible, type: 'image', bounding: 'raw',
                        style: { image: 'assets/img/create-chart/up-arrow.svg', width: 10, height: 10, opacity: 0.7 }
                      },
                      {
                        invisible: invisible, type: 'text', left: 20, id: 'drillUpText',
                        style: { fontSize: 12, fill: '#777', text: subtitle }
                      }
                    ],
                    onclick: function () {
                      that.drillDownData = slice(that.drillDownData, 0, that.drillDownData.length - 1);
                      if (that.drillDownData.length < that.colKeys[0].length) {
                        that.dataArray = that.calculateDataArray(optsData, that);
                        opt = {};
                        subtitle = '';
                        invisible = true, aux = [];
                        if (that.drillDownData && that.drillDownData.length > 0) {
                          subtitle = 'Drill up to : ' + that.drillDownData.join('>');
                          invisible = false;
                        }
                        graphic[0].children[0].invisible = invisible;
                        graphic[0].children[1].invisible = invisible;
                        graphic[0].children[1].style.text = subtitle;
                        if (params.componentSubType === 'scatter' || params.componentSubType === 'effectScatter') {
                          for (let i = 0; i < that.dataArray.length; i++) {
                            aux.push(that.dataArray[i][0]);
                          }
                          aux = uniq(aux);
                          extend(true, opt, { xAxis: { data: aux } });
                          extend(true, opt, { series: [{ type: params.componentSubType, data: that.dataArray }] });
                        } else {
                          extend(true, opt, { dataset: { source: that.dataArray } });
                        }
                        extend(true, opt, { graphic: graphic });
                        myChart.setOption(opt);
                      }
                    }
                  }
                ];

                if (params.componentSubType === 'scatter' || params.componentSubType === 'effectScatter') {
                  for (let i = 0; i < that.dataArray.length; i++) {
                    aux.push(that.dataArray[i][0]);
                  }
                  aux = uniq(aux);
                  extend(true, opt, { xAxis: { data: aux } });
                  extend(true, opt, { series: [{ type: params.componentSubType, data: that.dataArray }] });
                } else {
                  extend(true, opt, { dataset: { source: that.dataArray } });
                }
                extend(true, opt, { graphic: graphic });
                myChart.setOption(opt);

              }
            }
          });
        }
      });
    return null;
  }

}


